export default (props, traits) => {
  const { treatments } = traits

  return {
    root: {
      ...treatments.thick
    }
  }
}
